import { Dialog, DialogActions, DialogContent, DialogTitle, IconButton } from "@mui/material";
import { MdClose } from "react-icons/md";
import intl from "react-intl-universal";

import {
  formatBrl,
  formatCurrencyAmount,
  getHistoryKindMeta,
} from "../constants";

const DetailRow = ({ label, value }) => (
  <div>
    <p className="text-xs font-medium text-gray-500">{label}</p>
    <p className="mt-1 text-sm font-semibold text-brand-dark dark:text-gray-100">{value || "—"}</p>
  </div>
);

const getDetailFields = (item) => {
  const kindMeta = getHistoryKindMeta()[item.historyKind];

  switch (item.historyKind) {
    case "purchases":
      return [
        { label: intl.get("grid.transaction"), value: kindMeta?.label },
        { label: intl.get("grid.date"), value: item.date },
        { label: intl.get("grid.value"), value: formatBrl(item.amountBrl) },
        { label: intl.get("grid.status"), value: item.status },
        { label: "Ativo", value: item.asset?.toUpperCase() },
        { label: "Quantidade", value: formatCurrencyAmount(item.amount, item.asset) },
        { label: "Cotação", value: formatBrl(item.rate) },
        { label: "Método", value: item.method },
      ];
    case "withdrawals":
      return [
        { label: intl.get("grid.transaction"), value: kindMeta?.label },
        { label: intl.get("grid.date"), value: item.date },
        { label: intl.get("grid.status"), value: item.status },
        { label: "Ativo", value: item.asset?.toUpperCase() },
        { label: "Quantidade", value: formatCurrencyAmount(item.amount, item.asset) },
        { label: "Destino", value: item.destination },
        { label: "Método", value: item.method },
      ];
    case "transfers":
      return [
        { label: intl.get("grid.transaction"), value: kindMeta?.label },
        { label: intl.get("grid.date"), value: item.date },
        { label: intl.get("grid.status"), value: item.status },
        { label: "Ativo", value: item.asset?.toUpperCase() },
        { label: "Quantidade", value: formatCurrencyAmount(item.amount, item.asset) },
        { label: "Destinatário", value: item.recipient },
        { label: "Método", value: item.method },
      ];
    case "conversions":
      return [
        { label: intl.get("grid.transaction"), value: kindMeta?.label },
        { label: intl.get("grid.date"), value: item.date },
        { label: intl.get("grid.value"), value: formatCurrencyAmount(item.amountTo, item.to) },
        { label: intl.get("grid.status"), value: item.status },
        { label: "Origem", value: formatCurrencyAmount(item.amountFrom, item.from) },
        { label: "Cotação", value: item.rate },
      ];
    default:
      return [
        { label: intl.get("grid.date"), value: item.date },
        { label: intl.get("grid.status"), value: item.status },
      ];
  }
};

export const ContaInternacionalHistoryDetailModal = ({ open, onClose, item }) => {
  if (!item) return null;

  const fields = getDetailFields(item);

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle className="!flex !items-center !justify-between !pr-12 !text-base !font-bold !text-brand-dark">
        {intl.get("common.details")}
        <IconButton aria-label={intl.get("common.close")} onClick={onClose} size="small" className="!absolute !right-2 !top-2">
          <MdClose />
        </IconButton>
      </DialogTitle>

      <DialogContent className="!pt-2">
        <div className="space-y-4">
          {fields.map((field) => (
            <DetailRow key={field.label} label={field.label} value={field.value} />
          ))}
        </div>
      </DialogContent>

      <DialogActions className="!px-6 !pb-4">
        <button type="button" className="btn-primary" onClick={onClose}>
          {intl.get("common.close")}
        </button>
      </DialogActions>
    </Dialog>
  );
};
